import { render } from "./MessengerComponent.vue?vue&type=template&id=2a9d0934&scoped=true"
import script from "./MessengerComponent.vue?vue&type=script&lang=js"
export * from "./MessengerComponent.vue?vue&type=script&lang=js"

import "./MessengerComponent.vue?vue&type=style&index=0&id=2a9d0934&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9d0934"]])

export default __exports__